import { SET_FILTERS, SET_TAB } from "../actions/foldersOverview";
import {
	API_GET_PATIENT_CLOSED_FOLDER_FAIL,
	API_GET_PATIENT_CLOSED_FOLDER_SUCCESS,
	SET_PREVIOUS_FOLDER,
	API_GET_SEARCH_TEMP_FOLDERS,
	API_GET_SEARCH_TEMP_FOLDERS_FAIL,
	API_GET_SEARCH_TEMP_FOLDERS_SUCCESS,
	API_PATCH_CONFIRM_TEMP_FOLDER_SUCCESS,
	API_PATCH_CONFIRM_TEMP_FOLDER_FAIL,
	API_ADMIN_IMPORT_TEMP_FOLDERS_FAIL,
	API_ADMIN_IMPORT_TEMP_FOLDERS_SUCCESS,
} from "../actions/folder";
import { createReducer } from "@reduxjs/toolkit";
import { ErrorAction, errorHandler } from "utils/error";
import moment from "moment";
import { toast } from "react-toastify";

const initialState = {
	filters: {
		startDate: moment().format("YYYY-MM-DD"),
		endDate: moment().format("YYYY-MM-DD"),
		showDone: false,
		showFolders: false,
		page: 1,
		search: null,
		centers: false,
		box: false,
	},
	size: 10,
	patientClosedFolders: [],
	previousFolder: null,
	tempFolders: {
		loading: false,
		results: [],
		numberOfPages: 0,
		totalCount: 0,
	},
	openedTab: 0,
};

const foldersOverview = createReducer(initialState, {
	[SET_FILTERS]: (state, action) => {
		const { startDate, endDate, showDone, page, search, sizePage, centers, box } = action.payload.data;
		let backReturn = false;
		if (
			(!startDate || startDate === state.filters.startDate) &&
			(!endDate || endDate === state.filters.endDate) &&
			(!showDone || showDone === state.filters.showDone)
		)
			backReturn = true;
		if (startDate) state.filters.startDate = startDate instanceof Date ? moment(startDate).format("YYYY-MM-DD") : startDate;
		if (endDate) state.filters.endDate = endDate instanceof Date ? moment(endDate).format("YYYY-MM-DD") : endDate;
		if (startDate && moment(state.filters.startDate).isAfter(state.filters.endDate, "date")) state.filters.endDate = state.filters.startDate;
		if (endDate && moment(state.filters.startDate).isAfter(state.filters.endDate, "date")) state.filters.startDate = state.filters.endDate;
		if (showDone !== null) state.filters.showDone = showDone;
		if (page) state.filters.page = page;
		if (centers !== null) state.filters.centers = centers;
		if (sizePage) state.size = sizePage;
		if (search !== null && search !== "") state.filters.search = search;
		else if (search === "") state.filters.search = null;
		if (!backReturn) state.filters.page = 1;
		if (box !== null) state.filters.box = box;
	},

	[API_GET_PATIENT_CLOSED_FOLDER_FAIL]: (state, action) => {
		state.patientClosedFolders = [];
		errorHandler("Dossier terminé", ErrorAction.READ, action.error);
	},

	[API_GET_PATIENT_CLOSED_FOLDER_SUCCESS]: (state, action) => {
		state.patientClosedFolders = action.payload.data;
	},
	[SET_PREVIOUS_FOLDER]: (state, action) => {
		state.previousFolder = action.payload;
	},
	[API_GET_SEARCH_TEMP_FOLDERS]: (state, action) => {
		state.tempFolders.loading = true;
	},
	[API_GET_SEARCH_TEMP_FOLDERS_FAIL]: (state, action) => {
		state.tempFolders.loading = false;
		errorHandler("Dossier temporaire", ErrorAction.READ, action.error);
	},
	[API_GET_SEARCH_TEMP_FOLDERS_SUCCESS]: (state, action) => {
		state.tempFolders = action.payload.data;
		state.tempFolders.loading = false;
	},
	[API_PATCH_CONFIRM_TEMP_FOLDER_FAIL]: (state, action) => {
		errorHandler("Dossier temporaire", ErrorAction.UPDATE, action.error);
	},
	[API_PATCH_CONFIRM_TEMP_FOLDER_SUCCESS]: (state, action) => {
		toast.success("Dossier temporaire confirmé");
	},
	[SET_TAB]: (state, action) => {
		state.openedTab = action.payload;
	},
	[API_ADMIN_IMPORT_TEMP_FOLDERS_FAIL]: (state, action) => {
		errorHandler("Import dossiers temporaires", ErrorAction.UPDATE, action.error);
	},
	[API_ADMIN_IMPORT_TEMP_FOLDERS_SUCCESS]: (state, action) => {
		toast.success("Import terminé");
	},
});

export default foldersOverview;
